import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ArrowRight, Sparkles, ShieldCheck, Lock, Globe } from "lucide-react";
import { openWhatsAppContact } from "@/lib/whatsapp-contact";

export function MobileHero() {
  const { t } = useTranslation();
  return (
    <section className="relative overflow-hidden mob-surface-0 px-5 pb-12 pt-[calc(env(safe-area-inset-top)+88px)]">
      {/* subtle radial glow */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(60% 40% at 50% 0%, oklch(1 0 0 / 0.08) 0%, transparent 70%)",
        }}
      />
      <div className="relative flex flex-col items-center text-center">
        <div className="mb-5 inline-flex items-center gap-1.5 rounded-full border mob-hairline-strong bg-white/[0.03] px-3 py-1 text-[11px] font-medium tracking-tight text-white/80">
          <Sparkles className="h-3 w-3" />
          {t("hero.badge")}
        </div>
        <h1 className="mob-h1 text-balance text-white">
          {t("hero.titleA")}
          <br />
          <span className="text-white/55">{t("hero.titleB")}</span>
        </h1>
        <p className="mt-4 max-w-[34ch] text-[15px] leading-[1.45] text-white/65">
          {t("hero.subtitle")}
        </p>

        <div className="mt-7 flex w-full flex-col gap-2.5">
          <Link
            to="/signup"
            className="mob-tap inline-flex h-12 items-center justify-center gap-1.5 rounded-full bg-white text-[15px] font-semibold text-black"
          >
            {t("hero.ctaPrimary")} <ArrowRight className="h-4 w-4" />
          </Link>
          <button
            type="button"
            onClick={() => openWhatsAppContact()}
            className="mob-tap inline-flex h-12 items-center justify-center gap-1.5 rounded-full border mob-hairline-strong text-[15px] font-medium text-white"
          >
            {t("hero.ctaSecondary")} <ArrowRight className="h-4 w-4" />
          </button>
        </div>

        <div className="mt-8 grid w-full grid-cols-2 gap-y-3 text-[11px] uppercase tracking-[0.14em] text-white/50 justify-items-center">
          <span className="inline-flex items-center gap-1.5">
            <ShieldCheck className="h-3.5 w-3.5" /> {t("hero.badges.gdpr")}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Lock className="h-3.5 w-3.5" /> {t("hero.badges.crypto")}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Sparkles className="h-3.5 w-3.5" /> {t("hero.badges.aiAct")}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Globe className="h-3.5 w-3.5" /> {t("hero.badges.euData")}
          </span>
        </div>
      </div>
    </section>
  );
}
